import { configureStore } from "@reduxjs/toolkit";
import rootReduser from "../reducer";
import { persistStore } from "redux-persist";

const store = configureStore({
  reducer: rootReduser,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export default store;
